
(() => {
  const FLAGS = {
    es: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><defs><clipPath id='c'><circle cx='12' cy='12' r='12'/></clipPath></defs><g clip-path='url(%23c)'><rect width='24' height='24' fill='%23c60b1e'/><rect y='6' width='24' height='12' fill='%23ffc400'/></g></svg>",
    en: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><defs><clipPath id='c'><circle cx='12' cy='12' r='12'/></clipPath></defs><g clip-path='url(%23c)'><rect width='24' height='24' fill='%23b22234'/><g stroke='white' stroke-width='1.85'><path d='M0 3h24M0 6.7h24M0 10.5h24M0 14.2h24M0 18h24M0 21.7h24'/></g><rect width='10' height='10' fill='%233c3b6e'/></g></svg>",
    pl: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><defs><clipPath id='c'><circle cx='12' cy='12' r='12'/></clipPath></defs><g clip-path='url(%23c)'><rect width='24' height='24' fill='%23ffffff'/><rect y='12' width='24' height='12' fill='%23dc143c'/></g></svg>"
    // añade más: fr: "...", de: "...", etc.
  };

  // CSS inyectado una sola vez
  const css = `
    .lang-fx{position:relative;display:inline-block;font:inherit;margin-bottom: -5px;}
    .lang-fx__trigger{display:inline-flex;align-items:center;gap:5px;border:0px solid #d0d0d0;border-radius:6px;cursor:pointer;font:inherit;background:transparent}
    .lang-fx__list{position:absolute;top:calc(100% + 4px);left:0;z-index:9999;margin:0;padding:4px 0;list-style:none;min-width:100%;background:#fff;border:1px solid #d0d0d0;border-radius:6px;box-shadow:0 6px 18px rgba(0,0,0,.08)}
    .lang-fx__list li{display:flex;align-items:center;gap:8px;padding:8px 12px;cursor:pointer;white-space:nowrap}
    .lang-fx__list li:hover,.lang-fx__list li[aria-selected="true"]{background:#f3f4f6}
    .lang-fx__flag{width:18px;height:18px;border-radius:50%;background-repeat:no-repeat;background-size:cover;background-position:center;flex:0 0 auto}
    .lang-fx__hidden{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;border:0!important}
    .icon-caret {display: none !important;}
  `;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function enhance(select) {
    if (select.dataset.langFxDone) return;
    select.dataset.langFxDone = '1';

    const options = Array.from(select.options).map(o => ({
      value: o.value,
      label: o.textContent.trim(),
      selected: o.selected
    }));

    const root = document.createElement('div');
    root.className = 'lang-fx';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'lang-fx__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    const tFlag = document.createElement('span');
    tFlag.className = 'lang-fx__flag';
    const tLabel = document.createElement('span');
    const caret = document.createElement('span');
    caret.textContent = '▾';
    caret.setAttribute('aria-hidden', 'true');
    trigger.append(tFlag, tLabel, caret);

    const list = document.createElement('ul');
    list.className = 'lang-fx__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    const setFlag = (el, value) => {
      const url = FLAGS[value];
      el.style.backgroundImage = url ? `url("${url}")` : 'none';
    };

    options.forEach(opt => {
      const li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.dataset.value = opt.value;
      li.setAttribute('aria-selected', opt.selected ? 'true' : 'false');

      const flag = document.createElement('span');
      flag.className = 'lang-fx__flag';
      setFlag(flag, opt.value);

      li.append(flag, document.createTextNode(' ' + opt.label));
      list.appendChild(li);

      if (opt.selected) {
        setFlag(tFlag, opt.value);
        tLabel.textContent = opt.label;
      }
    });

    // inserta el custom justo antes del select y oculta el nativo
    select.parentNode.insertBefore(root, select);
    root.append(trigger, list);
    select.classList.add('lang-fx__hidden');
    root.appendChild(select); // lo metemos dentro para mantener el form intacto

    const open  = () => { list.hidden = false; trigger.setAttribute('aria-expanded','true'); };
    const close = () => { list.hidden = true;  trigger.setAttribute('aria-expanded','false'); };

    trigger.addEventListener('click', () => list.hidden ? open() : close());

    list.addEventListener('click', e => {
      const li = e.target.closest('li[role="option"]');
      if (!li) return;
      const value = li.dataset.value;

      list.querySelectorAll('li').forEach(o => o.setAttribute('aria-selected','false'));
      li.setAttribute('aria-selected','true');
      setFlag(tFlag, value);
      tLabel.textContent = li.textContent.trim();

      if (select.value !== value) {
        select.value = value;
        // dispara change → Shopify ejecuta on:change="/changeLanguage" y envía el form
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      close();
    });

    document.addEventListener('click', e => { if (!root.contains(e.target)) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  const init = () => {
    document.querySelectorAll('#dropdownSelect, select.localization-form__select')
      .forEach(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
